<template>
  <el-dialog :title="ar ? '选择出库明细' : '选择入库明细'" :visible.sync="inner" width="min(860px, 94vw)" append-to-body :close-on-click-modal="false" @open="load">
    <el-table :data="list" border height="360" @selection-change="rows => selected = rows">
      <el-table-column type="selection" width="46" />
      <el-table-column prop="sourceCode" :label="ar ? '出库单号' : '入库单号'" width="150" />
      <el-table-column prop="materialCode" label="编码" width="130" />
      <el-table-column prop="materialName" label="名称" min-width="140" />
      <el-table-column prop="remainQuantity" label="可挂账数量" width="110" align="right" />
      <el-table-column prop="price" label="单价" width="100" align="right" />
      <el-table-column label="可挂账金额" width="120" align="right">
        <template slot-scope="scope">{{ availableAmount(scope.row) }}</template>
      </el-table-column>
    </el-table>
    <span slot="footer">
      <el-button @click="inner = false">取消</el-button>
      <el-button type="primary" @click="confirm">确定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import request from '../api/request'
export default {
  props: { visible: Boolean, partnerId: String, excludeId: { type: String, default: '' }, ar: { type: Boolean, default: true } },
  data() { return { list: [], selected: [] } },
  computed: {
    inner: { get() { return this.visible }, set(v) { this.$emit('update:visible', v) } }
  },
  methods: {
    availableAmount(row) {
      return (Number(row.remainQuantity || 0) * Number(row.price || 0)).toFixed(2)
    },
    load() {
      if (!this.partnerId) { this.list = []; return }
      request.get('/finance/arap/pendingStockLines', {
        params: { kind: this.ar ? 'receivable' : 'payable', partnerId: this.partnerId, excludeId: this.excludeId || '' }
      }).then(res => { this.list = res.data || [] }).catch(err => {
        this.list = []
        this.$message.error((err && err.message) || '加载可挂账明细失败')
      })
    },
    confirm() {
      if (!this.selected.length) { this.$message.warning('请选择明细'); return }
      this.$emit('select', this.selected.map(row => ({
        ...row,
        quantity: Number(row.remainQuantity || 0),
        price: Number(row.price || 0),
        amount: Number(row.remainQuantity || 0) * Number(row.price || 0)
      })))
      this.inner = false
    }
  }
}
</script>
